import * as React from 'react';

import { ListView } from '@longline/aqua-ui/controls/ListView/ListView';
import { SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton';
import { SVG } from '@longline/aqua-ui/svg';
import { NumberFormatter } from '@longline/aqua-ui/formatters/NumberFormatter';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { StructureInfoBox } from '../../infoboxes/StructureInfoBox';
import { IStructure } from '../../types/IStructure';
import { Sprites } from '../../svg';
import { StructureCard } from './StructureCard';
import { useConfirm } from '../../contexts/confirm/ConfirmContext';
import { Pane } from '../../ui/Pane';
import { Message } from '@longline/aqua-ui/containers/Message';

const StructurePane = () => {
  const confirm = useConfirm();
  const globalState = useGlobalState();

  const handleAddCircle = () => {
    globalState.setMode('circle-builder');
  }

  const handleAddPolygon = () => {
    globalState.setMode('polygon-builder');
  }

  const handleDeleteAll = () => {
    globalState.clearStructures();
  }

  return (
    <>
      <Pane.Heading>
        <Pane.Title>Structures</Pane.Title>
      </Pane.Heading>
      <Pane.Subheader expandable action={<>
          <SecondaryButton title="Add circular cage" positive icon={Sprites.Icons.AddCircle} onClick={handleAddCircle}/>
          <SecondaryButton title="Add polygon cage" positive icon={Sprites.Icons.AddPolygon} onClick={handleAddPolygon}/>
        </>}>
        Add structure
      </Pane.Subheader>
      
      <ListView
        dark
        data={globalState.structures}
        active={globalState.selectedStructures[0]}
        onClick={(structure) => globalState.toggleStructureSelection(structure, false)}
        shadow
        aux={<StructureInfoBox/>}
        total
        singular="structure"
        plural="structures"
        noData={<Message margin>There are no structures yet.</Message>}
        rowHeight={56}
      >
        <ListView.Column active width={3} name="Name">{(item: IStructure) => <StructureCard structure={item}/>}</ListView.Column>
        <ListView.Column active={globalState.expanded} width="150px" align="right" name="Stocking">{(item: IStructure) => <NumberFormatter value={item.stocking} decimals={0}/>}</ListView.Column>
      </ListView>

      {globalState.structures.length > 0 && 
        <Pane.Fab negative title="Delete all structures" icon={SVG.Icons.Delete} onClick={() => confirm.start(handleDeleteAll, "Delete all structures", "Are you sure you wish to delete all structures?")}/>}
    </>
  )
}

export { StructurePane }
